import React, { forwardRef } from 'react';
import cn from 'classnames';

import styles from './input.module.scss';

export type InputRefProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  error?: boolean;
  viewOnly?: boolean;
};

export const InputRef = forwardRef<HTMLInputElement, InputRefProps>(
  (
    {
      placeholder = '',
      size = 20,
      className,
      value,
      disabled,
      viewOnly = false,
      onChange = () => null,
      error,
      ...props
    },
    ref,
  ) => {
    return (
      <div className={styles.container}>
        <input
          {...props}
          ref={ref}
          autoComplete="off"
          className={cn(styles.input, { [styles.inputError]: error }, className, {
            [styles.viewOnly]: viewOnly,
          })}
          disabled={disabled || viewOnly}
          placeholder={placeholder}
          size={size}
          value={value}
          onChange={onChange}
        />
      </div>
    );
  },
);

export const InputNoRef: React.FC<InputRefProps> = ({
  placeholder = '',
  disabled = false,
  autoFocus = false,
  viewOnly = false,
  className,
  error,
  value = '',
  ...props
}) => (
  <div className={styles.inputContainer}>
    <input
      autoComplete="off"
      autoFocus={autoFocus}
      className={cn(styles.input, className, {
        [styles.viewOnly]: viewOnly,
        [styles.inputError]: error,
      })}
      disabled={disabled || viewOnly}
      placeholder={placeholder}
      value={value}
      {...props}
    />
  </div>
);
